import { initVariableBg } from "./_variable-bg";
import { initIframes } from "./_iframes";

jQuery(function ($) {
    initVariableBg($);
    initIframes($);
});